export function getCianAnalyticsObjectPage() {
  var _window, _window$CianAnalytics;
  return ((_window = window) === null || _window === void 0 ? void 0 : (_window$CianAnalytics = _window.CianAnalytics) === null || _window$CianAnalytics === void 0 ? void 0 : _window$CianAnalytics.service.config.page) || {};
}